// 20240930：主页上己方的 CSS 和 JS 的打包和注入
// 注：通过该配置文件管理了页面上需要的资源，所以页面上的 <link href> <script href> 标签需要删除掉
// 主页上第三方的 CSS 和 JS 通过 HtmlWebpackTagsPlugin 插件管理
// // 导入样式表
// // 这里的 @css 实际指向 dist/public/css
// import "@css/global.css";
// import "@css/commonHead.css";
// import "@css/index.css";
// import "@css/commonFooter.css";
// // 导入公共库或脚本：所有页面通用它部分，单独的入口文件管理
// // 这两个是第三方静态资源，每个页面是都要有
// import '@js/ejs.min.js';
// // '/js/axios/dist/axios.min.js';
// import '@js/logToConsoleAndServer.js';
// import '@js/commonHead.js';
// import '@js/commonFooter.js';
// import '@js/common/clickFlame.js';

// 20241002: 将 webpack.config.js 和 wpEntry 目录向后移入到 dist 目录中了，直接使用相对路径！
//           这里出现的资源都将被合并打包 成 bundle 包
// 相对于本文件的相对路径！
// CSS:
// 1、公共部分
import "../public/css/global.css";
import "../public/css/commonHead.css";
import "../public/css/messageDialogBox.css";
import "../public/css/dataEditModal.css";
// 20251028：signupAndLogin.ejs 页面不再做为单独访问页面管理
import "../public/css/signupAndLogin.css";
import "../public/css/commonFooter.css";
// 2、独有部分
// import "../public/css/checkoutModal.css"; // 取消了 WKD 组件 ，所以不再需要
// import "../public/css/scanToPay.css";  // 取消了 WKD 组件 ，所以不再需要
import "../public/css/index.css";

// JS:
// 1、公共部分 -- 基础设施
// 通过静态资源的方式，导入第三方库
// 这两个是第三方静态资源，通用性，每个页面都要有。—— 构建时做为静态资源注入页面进行管理，不打包！
// import '../public/js/ejs.min.js';
// '/js/axios/dist/axios.min.js';
import '../public/js/common/appVariables.js';  // 20260905 Add，要优先于 indexedDBManager.js
// 20251119：只需在 commonHead 入口中包含即可，其它入口不需要再包含！-> 
// 20260420 取消 commonHead 入口，改为自己 SPA 页面自己管理
import '../public/js/common/pagesMessageBus.js';  // 这是基础设施，优先加载初始化！

import '../public/js/common/mountGlobalObjects.js';
import '../public/js/common/axiosInterceptor.js';  // 20260905 Add

import '../public/js/commonHead.js';
import '../public/js/messageDialogBox.js';
import '../public/js/common/clickFlame.js';
import '../public/js/dataEditModal.js'
import '../public/js/common/pagaDataLifeCycleManager.js'  // 20260420  页面数据中心
import '../public/js/common/indexedDBManager.js';  // 20260420 DB 管理器
// 20251028：signupAndLogin.ejs 页面不再做为单独入口页面管理
import '../public/js/signupAndLogin.js';
// 开发阶段不引用该脚本，正式上线时测试后引入
// import '../public/js/commonFooter.js';

// 2、独有部分
// 通过打包的方式管理己方页面上的库
// 20241019: 改模板文件中 webpackage 动态注入动态加载标签 dynamicLoadSIA 动态管理加载，不再打包资源 -- 放弃的方案
//           -->> 要打包！单独使用的页面上使用打包的文件，宿主 和 可寄生页面使用动态加载
//           <script type="module" src="/js/common/dynamicLoadSIA.js"></script>
// import '../public/js/socialInteraction.js';  // 20260225：改为只在 training 和 service 页面使用 WKD 组件
// import '../public/js/checkoutModal.js'; // 20260225：改为只在 training 和 service 页面使用 WKD 组件
import '../public/js/index.js';
